import { Web3Button } from '@web3modal/react';

export default function Connect() {
  return (
    <div className="flex flex-row items-center justify-center flex-wrap gap-2">
      <Web3Button avatar="hide" label="WalletConnect" />
    </div>
  );
}
